<template>
  <div>
    <!-- Hero Section -->
    <section class="hero text-center">
      <div class="container">
        <h1>Better Sleep Starts Here With Oshewon fabrics</h1>
        <p>
          Experience the ultimate comfort and support for a rejuvenating night's
          sleep. Shop our premium collection today.
        </p>
        <router-link to="/products?category=mattresses" class="btn"
          >Shop Mattresses</router-link
        >
      </div>
    </section>

    <!-- Categories Section -->
    <section class="categories">
      <div class="container">
        <div class="categories-grid">
          <div class="category-item" @click="goToCategory('mattresses')">
            <div class="icon">
              <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M56 22a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2zM44 32H34a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm-20 0H14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zM8 18h48v-2a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2z"
                />
              </svg>
            </div>
            <h4>Mattress</h4>
          </div>
          <div class="category-item" @click="goToCategory('pillows')">
            <div class="icon">
              <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M51 20H13a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h38a5 5 0 0 0 5-5V25a5 5 0 0 0-5-5zm-2 17a3 3 0 0 1-3 3H17a3 3 0 0 1-3-3V27a3 3 0 0 1 3-3h31a3 3 0 0 1 3 3z"
                />
              </svg>
            </div>
            <h4>Pillows</h4>
          </div>
          <div class="category-item" @click="goToCategory('bedding')">
            <div class="icon">
              <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M52 20H12a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4V24a4 4 0 0 0-4-4zm-2 26H14V26h36zM12 18h40a2 2 0 0 0 0-4H12a2 2 0 0 0 0 4z"
                />
              </svg>
            </div>
            <h4>Bedding</h4>
          </div>
          <div class="category-item" @click="goToCategory('bases')">
            <div class="icon">
              <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M54 28H10a2 2 0 0 0-2 2v18h48V30a2 2 0 0 0-2-2zM22 42h-8v-4h8zm14 0h-8v-4h8zm14 0h-8v-4h8zM54 18H10a2 2 0 0 0-2 2v4h48v-4a2 2 0 0 0-2-2z"
                />
              </svg>
            </div>
            <h4>Bases</h4>
          </div>
          <div class="category-item" @click="goToCategory('bundles')">
            <div class="icon">
              <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M54 16H10a2 2 0 0 0-2 2v30a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V18a2 2 0 0 0-2-2zm-2 28H12V20h38v24zM34 38h-4v-6h-6v-4h6v-6h4v6h6v4h-6z"
                />
              </svg>
            </div>
            <h4>Bundles</h4>
          </div>
        </div>
      </div>
    </section>

    <!-- Two Column Layouts -->
    <section class="section-bg">
      <div class="container">
        <div class="two-col-layout">
          <div class="image-content">
            <img
              src="https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=1965&auto=format&fit=crop"
              alt="Woman sleeping comfortably in a bright, airy room"
              loading="lazy"
            />
          </div>
          <div class="text-content">
            <h2>Invigorating mornings start with a good night's sleep.</h2>
            <p>
              Our pillows are designed to provide optimal neck support and
              alignment, ensuring you wake up refreshed and pain-free.
            </p>
            <router-link to="/products?category=pillows" class="btn"
              >Shop Pillows</router-link
            >
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="container">
        <div class="two-col-layout">
          <div class="text-content">
            <h2>Built with the best for your best sleep.</h2>
            <p>
              We use premium, durable materials to craft mattresses that stand
              the test of time. Enjoy years of consistent comfort and support.
            </p>
            <a href="#" class="btn">Learn About Materials</a>
          </div>
          <div class="image-content">
            <img
              src="https://images.unsplash.com/photo-1566694271355-9e0a5fb740b5?q=80&w=1974&auto=format&fit=crop"
              alt="Close-up of mattress layers and fabric"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Product Lineup -->
    <section class="product-lineup section-bg">
      <div class="container text-center">
        <h2>Meet Our Line-up of Luxury Mattresses</h2>
        <div class="product-grid">
          <div
            class="product-card"
            v-for="product in featuredProducts"
            :key="product.id"
          >
            <img :src="product.image" :alt="product.name" loading="lazy" />
            <div class="product-card-content">
              <h4>{{ product.name }}</h4>
              <p class="price">${{ product.price.toLocaleString() }}</p>
              <router-link
                :to="`/product/${product.id}`"
                class="btn btn-outline"
                >Shop Now</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Additional sections -->
    <section>
      <div class="container">
        <div class="two-col-layout">
          <div class="image-content">
            <img
              src="https://images.unsplash.com/photo-1505693314120-0d443867891c?w=800&h=600&fit=crop"
              alt="Luxury silk pillowcases on a made bed"
              loading="lazy"
            />
          </div>
          <div class="text-content">
            <h2>3x Life-Sleeping On Silk</h2>
            <p>
              Indulge in the luxury of our silk pillowcases. They're gentle on
              your skin and hair, reducing friction and preventing sleep
              creases.
            </p>
            <a href="#" class="btn">Shop Silk</a>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section text-center">
      <div class="container">
        <h2>Award-Winning Layers Of Comfort</h2>
        <p>
          Our innovative multi-layer design provides targeted support and
          pressure relief for every sleep style.
        </p>
        <a href="#" class="btn">Learn More</a>
      </div>
    </section>

    <!-- Testimonials -->
    <section class="section-bg">
      <div class="container">
        <div class="text-center section-title">
          <h2>What People Say</h2>
        </div>
        <div class="testimonials-grid">
          <div
            class="testimonial-card"
            v-for="testimonial in testimonials"
            :key="testimonial.id"
          >
            <p>"{{ testimonial.text }}"</p>
            <div class="testimonial-author">
              <img
                :src="testimonial.author.image"
                :alt="testimonial.author.name"
                loading="lazy"
              />
              <div>
                <span class="name">{{ testimonial.author.name }}</span
                ><br />
                <span class="title">{{ testimonial.author.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Blog Section -->
    <section>
      <div class="container">
        <div class="text-center section-title">
          <h2>Latest Blog & News</h2>
        </div>
        <div class="blog-grid">
          <div class="blog-post" v-for="post in blogPosts" :key="post.id">
            <img :src="post.image" :alt="post.title" loading="lazy" />
            <div class="blog-post-content">
              <h4>{{ post.title }}</h4>
              <p>{{ post.excerpt }}</p>
              <a href="#">{{ post.linkText }} &rarr;</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "Home",
  setup() {
    const router = useRouter();

    const featuredProducts = ref([
      {
        id: "mattress-1",
        name: "The Original",
        price: 995,
        image:
          "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=800&h=600&auto=format&fit=crop",
      },
      {
        id: "mattress-2",
        name: "The Hybrid",
        price: 1295,
        image:
          "https://images.unsplash.com/photo-1505693314120-0d443867891c?w=800&h=600&fit=crop",
      },
      {
        id: "mattress-3",
        name: "The Latex",
        price: 1595,
        image:
          "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=800&h=600&auto=format&fit=crop",
      },
      {
        id: "base-1",
        name: "Adjustable Base",
        price: 795,
        image:
          "https://images.unsplash.com/photo-1505693314120-0d443867891c?w=800&h=600&fit=crop",
      },
    ]);

    const testimonials = ref([
      {
        id: 1,
        text: "I've never slept better! The mattress is the perfect combination of soft and firm. My back pain is gone.",
        author: {
          name: "Jane S.",
          title: "Verified Buyer",
          image:
            "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1887&auto=format&fit=crop",
        },
      },
      {
        id: 2,
        text: "Absolutely love my new pillows. They stay cool all night and provide amazing support for my neck.",
        author: {
          name: "Mike D.",
          title: "Verified Buyer",
          image:
            "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?q=80&w=1887&auto=format&fit=crop",
        },
      },
      {
        id: 3,
        text: "The best investment I've made for my health. Waking up feeling refreshed has been a game-changer.",
        author: {
          name: "Lisa W.",
          title: "Verified Buyer",
          image:
            "https://images.unsplash.com/photo-1521119989659-a83eee488004?q=80&w=1923&auto=format&fit=crop",
        },
      },
    ]);

    const blogPosts = ref([
      {
        id: 1,
        title: "The Science of Deep Sleep",
        excerpt:
          "Discover how to optimize your sleep cycles for better health and cognitive function.",
        image:
          "https://images.unsplash.com/photo-1444703686981-a3abbc4d42e2?q=80&w=2070&auto=format&fit=crop",
        linkText: "Read More",
      },
      {
        id: 2,
        title: "Choosing the Right Pillow for You",
        excerpt:
          "A guide to finding the perfect pillow based on your sleeping position.",
        image:
          "https://images.unsplash.com/photo-1542359649-31e03cdde4fe?q=80&w=2070&auto=format&fit=crop",
        linkText: "Read More",
      },
      {
        id: 3,
        title: "Creating a Relaxing Bedtime Routine",
        excerpt:
          "Tips and tricks to help you wind down and prepare for a restful night.",
        image:
          "https://images.unsplash.com/photo-1515023677547-593d7638cbd6?q=80&w=2070&auto=format&fit=crop",
        linkText: "Read More",
      },
    ]);

    const goToCategory = (category) => {
      router.push(`/products?category=${category}`);
    };

    return {
      featuredProducts,
      testimonials,
      blogPosts,
      goToCategory,
    };
  },
};
</script>
